module.exports = __webpack_public_path__ + "media/flags/tz-989068bc.svg";